import { Node, mergeAttributes } from '@tiptap/core'
import { ReactNodeViewRenderer } from '@tiptap/react'

import { Spoiler } from './Spoiler'

const SpoilerExtension = Node.create({
  name: 'spoiler',

  group: 'block',

  content: 'inline*',

  addAttributes() {
    return {
      toggle: {
        default: false,
      },
    }
  },

  parseHTML() {
    return [
      {
        tag: 'spoiler',
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return ['spoiler', mergeAttributes(HTMLAttributes), 0]
  },

  addNodeView() {
    return ReactNodeViewRenderer(Spoiler)
  },
})

export default SpoilerExtension
